export const WEBSOCKET_MESSAGE_TYPES = {
    NETWORK_GRAPH_UPDATE: "NETWORK_GRAPH_UPDATE",
    TOAST_MESSAGE: "TOAST_MESSAGE",
    ALIGNMENT_SESSION_STATUS: "ALIGNMENT_SESSION_STATUS",
    ALIGNMENT_RECOMMENDATIONS_READY: "ALIGNMENT_RECOMMENDATIONS_READY",
    CLUSTERING_RUN_UPDATED: "CLUSTERING_RUN_UPDATED",
    COMMENT_ADDED: "COMMENT_ADDED",
    THREAD_STATUS_CHANGED: "THREAD_STATUS_CHANGED",
};
